const initialState = {
  visible: false,
  startDate: '',
  endDate: '',
  kind: '',
  requesting_report: false,
  report_success: false,
  success_message: ''
};

export function dialog_report_email(state = initialState, action) {
  switch (action.type) {
    case 'OPEN_REPORT_EMAIL_MODAL':
      return {
        ...state,
        visible: true,
        startDate: action.payload.startDate,
        endDate: action.payload.endDate,
        kind: action.payload.kind
      };
    case 'REPORT_REQUEST_START':
      return {
        ...state,
        requesting_report: true
      };
    case 'REPORT_REQUEST_SUCCESS':
      return {
        ...state,
        requesting_report: false,
        report_success: true,
        success_message: action.payload.message
      };
    case 'CLOSE_REPORT_EMAIL_MODAL':
      return {
        ...state,
        visible: false,
        startDate: '',
        endDate: '',
        kind: '',
        requesting_report: false,
        report_success: false,
        success_message: ''
      };
    default:
      return state;
  }
}
